module.exports = __webpack_public_path__ + "fonts/CenturyGothic-Bold.fc75a6ed.eot";